import { App } from '@capacitor/app';
export default defineNuxtPlugin((app) => {
  onNuxtReady(async () => {
    await App.addListener('appUrlOpen', async function (event) {
      // ToDo: Find a more stable way to get the full path
      const slug = event.url.split('.de').pop()
      if (slug) {
        await navigateTo(slug)
      }
    })
  })
})
